import styled from "styled-components";

// region Interface Props
interface IImageContainerProps {
  isFileChosen: boolean;
  backgroundColor?: string;
}

interface IModalImageProps {
  percentageSizeScreen: number;
}

// endregion Interface Props

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 130px;
`;

const ImageContainer = styled.div<IImageContainerProps>`
  height: 130px;
  border: ${(props) => (props.isFileChosen ? "5px solid red" : "5px solid black")};
  border-radius: 10px;
  box-shadow: 5px 5px 15px #00000066;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: blue;
    transition: border-color 200ms;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background-color: ${({ backgroundColor }) => backgroundColor ?? "unset"};
  }
`;

const OptionsContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  display: none;

  ${ImageContainer}:hover & {
    display: block;
  }
`;

const OptionButton = styled.button`
  background-color: transparent;
  color: white;
  border: none;
  padding: 10px;
  display: block;
  width: 100%;
  text-align: left;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 255, 0.5);
  }
`;

const FileName = styled.span`
  font-size: 17px;
  color: red;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 115%;

  &:empty::before {
    content: "\\00a0";
  }
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

const ModalImage = styled.img<IModalImageProps>`
  min-width: ${(props) => (props.percentageSizeScreen)}vw;
  min-height: ${(props) => (props.percentageSizeScreen)}vh;
  max-width: ${(props) => (props.percentageSizeScreen)}vw;
  max-height: ${(props) => (props.percentageSizeScreen)}vh;
  object-fit: contain;
`;

export default {
  Container,
  ImageContainer,
  OptionsContainer,
  OptionButton,
  FileName,
  ModalContainer,
  ModalImage
};
